import { last } from '../last';
import { findIndexes } from '../findIndexes';
/**
 * Finds the last index in an array that matches the predicate
 *
 * @since v2.27.0
 * @category Array
 * @template {T} - The type of the array
 * @param {T[]} array - The array of items
 * @param {(item: T) => boolean} predicate - The predicate to determine if an item in the array is a match
 * @returns {number}
 * @example
 * const array = [7, 25, 21, 17, 42];
 *
 * findLastIndex(array, item => item >= 25 )  //=> 4
 * @docgen_example
 * const array = [7, 25, 21, 17, 42];
 *
 * findLastIndex(array, item => item >= 25 );
 */
export var findLastIndex = function (array, predicate) { return last(findIndexes(array, predicate), -1); };
